import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import BlockContent from "../../block-content";

const SpecialCaseHomeAnimals = () => {
  const data = useStaticQuery(graphql`
    query homeAnimalsQuery {
      homeAnimals: sanitySpecialCaseHomeAnimals {
        id
        title
        _rawBody
      }
    }
  `);

const homeAnimalsData = (data || {}).homeAnimals;

  return (
    <>
    {/* <h1>Spezialfall bei Heimtierarten</h1> */}
      <h1>{homeAnimalsData.title}</h1>
      <BlockContent blocks={homeAnimalsData._rawBody || []} />
    </>
  );
};

export default SpecialCaseHomeAnimals;
